module.exports = __webpack_public_path__ + "img/企业历程.462aee35.png";